module.exports = __webpack_public_path__ + "static/img/logo-invision.4731441a.svg";